import { getPeopleCardRouteStore } from '../../store/Store';

export default function attachPeopleCardRoutes(
    baseGetCurrentRoute: (routePrefix?: string) => string[],
    routePrefix?: string
) {
    return () => {
        const route: string[] = routePrefix ? [routePrefix] : [];
        const { currentRoute } = getPeopleCardRouteStore();
        if (currentRoute && currentRoute.routeIdType) {
            route.push('card');
            route.push(currentRoute.routeIdType.toString());

            currentRoute.routeId && route.push(currentRoute.routeId);
            currentRoute.view && route.push(currentRoute.view);
            return route;
        }

        return baseGetCurrentRoute(routePrefix);
    };
}
